import { render, staticRenderFns } from "./CargosPendentesClube.vue?vue&type=template&id=181e4436"
import script from "./CargosPendentesClube.vue?vue&type=script&lang=ts"
export * from "./CargosPendentesClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports